import React from "react"
import Image from "./image"

const Stores = () => (
  <div className="stores">
    <div className="columns">
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/hinoyacurry.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/pancho.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/kinniku_shokudo.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/bugermania.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/bunnydinner.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/gapaoshokudo.png" />
          </div>
        </div>
      </div>
    </div>
    <div className="columns">
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/guzman.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/frijoles.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/toraji.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/tacorico.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/sakurashokudo.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/highfive.png" />
          </div>
        </div>
      </div>
    </div>
    <div className="columns">
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/dai.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/beefman.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/cosicosi.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/chickenworks.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/itadaki.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/vingo.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Stores
